// This lives in my-account-lib's eager-safe `shared` subpath (no lazy route code), so importing
// it statically here doesn't pull in the lazy screens.
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ActivityLogConfig } from '@keeps-platform-frontend-workspace/my-account/shared';

export const myAccountActivityLogConfig: ActivityLogConfig = {
  usersFilterRoleIds: ['77e3a833-94b5-4c37-891d-988513eabb67', 'e67234f4-957b-483d-badc-2fbcd6cd4173'],
  actionKeys: ['MYACCOUNT.INVITE_USERS', 'MYACCOUNT.UPDATE_USERS_STATUS'],
  getAction: (item) => {
    if (item.actionKey === 'MYACCOUNT.UPDATE_USERS_STATUS') {
      return item.actionPayload?.['status'] ? 'ACTIVATE_USERS' : 'DEACTIVATE_USERS';
    }

    return item.actionKey;
  },
};
